// Route of one branch's Jobs page (Branch Jobs menu, redirects, links).
export const expenseBranchPath = (centerId) => `/expense-management/branch/${centerId}`;
